export const environment = {
  production: true,
  apiURL: 'https://api.revupportal.com',
  s3Bucketname: 's3revupportal',
  sentryDsn: 'https://83df539b6022e6d9fe99cb8545526fdc@o4510579364528128.ingest.us.sentry.io/4510585241665536',
  trainingLibraryUrl: 'https://library.revupportal.com',
  // Base URL of the customer app (hosts /ref-form and /register). Must match the server's
  // REFERRAL_LINK_URL host. TODO: confirm the actual customer-app production domain before release.
  customerAppUrl: 'https://customer.revupportal.com',
};
